module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-34.02e6b16f.png";